module.exports = __webpack_public_path__ + "assets/c14abe713169861958f1578900c0bc36.png";